import api from './api';

const BASE = '/api/ehs';

export const ehsService = {
  // Incidents
  getIncidents: (params) => api.get(`${BASE}/incidents/`, { params }),
  getIncident: (id) => api.get(`${BASE}/incidents/${id}/`),
  createIncident: (data) => api.post(`${BASE}/incidents/`, data),
  updateIncident: (id, data) => api.put(`${BASE}/incidents/${id}/`, data),
  patchIncident: (id, data) => api.patch(`${BASE}/incidents/${id}/`, data),
  deleteIncident: (id) => api.delete(`${BASE}/incidents/${id}/`),

  // Incident Types
  getIncidentTypes: (params) => api.get(`${BASE}/incident-types/`, { params }),
  createIncidentType: (data) => api.post(`${BASE}/incident-types/`, data),
  updateIncidentType: (id, data) => api.put(`${BASE}/incident-types/${id}/`, data),
  deleteIncidentType: (id) => api.delete(`${BASE}/incident-types/${id}/`),

  // Severity Levels
  getSeverityLevels: (params) => api.get(`${BASE}/severity-levels/`, { params }),
  createSeverityLevel: (data) => api.post(`${BASE}/severity-levels/`, data),
  updateSeverityLevel: (id, data) => api.put(`${BASE}/severity-levels/${id}/`, data),
  deleteSeverityLevel: (id) => api.delete(`${BASE}/severity-levels/${id}/`),

  // Incident Statuses
  getIncidentStatuses: (params) => api.get(`${BASE}/incident-statuses/`, { params }),
  createIncidentStatus: (data) => api.post(`${BASE}/incident-statuses/`, data),
  updateIncidentStatus: (id, data) => api.put(`${BASE}/incident-statuses/${id}/`, data),
  deleteIncidentStatus: (id) => api.delete(`${BASE}/incident-statuses/${id}/`),

  // Actions / Attachments / Comments
  getActions: (params) => api.get(`${BASE}/actions/`, { params }),
  createAction: (data) => api.post(`${BASE}/actions/`, data),
  updateAction: (id, data) => api.put(`${BASE}/actions/${id}/`, data),
  deleteAction: (id) => api.delete(`${BASE}/actions/${id}/`),

  getAttachments: (params) => api.get(`${BASE}/attachments/`, { params }),
  createAttachment: (formData) => api.post(`${BASE}/attachments/`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  deleteAttachment: (id) => api.delete(`${BASE}/attachments/${id}/`),

  getComments: (params) => api.get(`${BASE}/comments/`, { params }),
  createComment: (data) => api.post(`${BASE}/comments/`, data),
  deleteComment: (id) => api.delete(`${BASE}/comments/${id}/`),

  // Assignable users (for incident action "Assigned To")
  getAssignableUsers: (params) => api.get(`${BASE}/assignable-users/`, { params }),
};

export default ehsService;
